import { render, staticRenderFns } from "./MypageLikesPage.vue?vue&type=template&id=265bad38&"
import script from "./MypageLikesPage.vue?vue&type=script&lang=js&"
export * from "./MypageLikesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports